import styles from './styles.module.scss';
import { type CSSProperties, forwardRef, type LegacyRef, ReactNode } from 'react';

type ButtonProps = {
  onClick?: (
    event: React.MouseEvent<HTMLDivElement>,
  ) => void | React.MouseEventHandler<HTMLButtonElement> | React.MouseEventHandler<HTMLDivElement>;
  type?: 'gray' | 'golden' | 'red' | 'green' | 'stamp' | 'stamp_red';
  disabled?: boolean;
  shadow?: boolean;
  hoverable?: boolean;
  children?: ReactNode;
};

export const SmallButton = forwardRef(
  (
    { onClick, type = 'gray', disabled = false, hoverable = true, shadow = false, children, ...rest }: ButtonProps,
    forwardedRef: LegacyRef<HTMLDivElement>,
  ) => {
    return (
      <div
        ref={forwardedRef}
        className={`${styles.smallButton} ${disabled ? styles.disabled : ''} ${hoverable ? styles.hoverable : ''}`}
        onClick={disabled ? undefined : onClick}
        {...rest}
      >
        <button
          disabled={disabled}
          style={
            {
              '--background': `url('../ui/buttons/small_button_${type}.png')`,
              '--shadow': shadow ? '4px 4px 0 0 var(--light-yellow)' : 'none',
            } as CSSProperties
          }
          className={`${styles.button}`}
        >
          {children}
        </button>
      </div>
    );
  },
);
